const actions = {
    GET_ECO_DRIVING_DATA_BY_VEHICLE_ID: "ecoDriving/GET_ECO_DRIVING_DATA_BY_VEHICLE_ID",
    SET_ECO_DRIVING_DATA_BY_VEHICLE_ID: "ecoDriving/SET_ECO_DRIVING_DATA_BY_VEHICLE_ID",

    GET_ECO_DRIVING_GLOBAL_SETTINGS: "ecoDriving/GET_ECO_DRIVING_GLOBAL_SETTINGS",
    SET_ECO_DRIVING_GLOBAL_SETTINGS: "ecoDriving/SET_ECO_DRIVING_GLOBAL_SETTINGS",

    GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID: "ecoDriving/GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID",
    SET_ECO_DRIVING_SETTING_BY_VEHICLE_ID: "ecoDriving/SET_ECO_DRIVING_SETTING_BY_VEHICLE_ID",

    GET_ECO_DRIVING_SETTING_UPDATE_BY_VEHICLE_ID: "ecoDriving/GET_ECO_DRIVING_SETTING_UPDATE_BY_VEHICLE_ID",
    SET_ECO_DRIVING_SETTING_UPDATE_BY_VEHICLE_ID: "ecoDriving/SET_ECO_DRIVING_SETTING_UPDATE_BY_VEHICLE_ID",


};

export default actions;